import api from './api';

/**
 * Compromissos da Agenda.
 *
 * Consolida o que estava dividido entre este arquivo e `userScheduleService`,
 * que devolviam formatos diferentes para a mesma API. Aqui tudo devolve `data`.
 */

/** Devolve `{ appointments, count, hasMore }` — paginação vem do servidor. */
export const listAppointments = async (params = {}) => {
  const { data } = await api.get('/appointments', { params });
  return data;
};

export const getAppointment = async (id) => {
  const { data } = await api.get(`/appointments/${id}`);
  return data;
};

export const createAppointment = async (payload) => {
  const { data } = await api.post('/appointments', payload);
  return data;
};

export const updateAppointment = async (id, payload) => {
  const { data } = await api.put(`/appointments/${id}`, payload);
  return data;
};

/**
 * Cancela — o backend não apaga o registro. O horário volta a ficar livre, mas
 * quem marcou, quem cancelou e por quê continuam gravados.
 */
export const cancelAppointment = async (id, cancelReason) => {
  const { data } = await api.delete(`/appointments/${id}`, {
    params: cancelReason ? { cancelReason } : undefined,
  });
  return data;
};

/** Aviso da barra superior — devolve `{ enabled, appointment }`. */
export const getNextAppointment = async () => {
  const { data } = await api.get('/appointments/next');
  return data;
};

export const getAgendaSettings = async () => {
  const { data } = await api.get('/agenda/settings');
  return data;
};

export const updateAgendaSettings = async (payload) => {
  const { data } = await api.put('/agenda/settings', payload);
  return data;
};
